export default __webpack_public_path__ + "static/media/milena_s.213082da.jpg";